/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/scripts/collections/searchanise/searchanise-badges.js"
/*!*******************************************************************!*\
  !*** ./src/scripts/collections/searchanise/searchanise-badges.js ***!
  \*******************************************************************/
() {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var _initBadges = function _initBadges() {
  var $ = window.Searchanise.$;
  $(document).on('Searchanise.DataRequestEnd', function (event, type, params, data) {
    // Only the results payload owns the badge data (mirrors the update-data module): the widget
    // fires the same event for autocomplete / recommendation requests, and buildProductsData ends
    // in renderBadges(), which scans the WHOLE document and would re-insert the whole-pool "-N%"
    // sticker over a card whose customer-selected colour had just removed it. A 'results' request
    // is always followed by the widget re-render + ResultsUpdated, where the sticker is re-synced.
    if (type !== 'results') return;
    window.SEARCHANISE_CURRENT_ITEMS = data.items;
    buildProductsData(data.items);
  });
  $(document).on('Searchanise.ResultsUpdated', function () {
    // jQuery stops dispatching the remaining handlers when one throws: a throw here would
    // starve the card price render, leaving the normalised min price without its strike-through.
    try {
      renderBadges();
      updateProductInfo();
    } catch (e) {
      // let the later handlers run
    }
  });
};
if (window.Searchanise && window.Searchanise.$) {
  _initBadges();
} else {
  document.addEventListener('Searchanise.Loaded', _initBadges);
}

/**
 * Analyzes product availability considering both total quantity and individual variants.
 * Crucial for third-party inventory like Shopify Collective where quantity_total might be empty.
 */
var checkProductAvailability = function checkProductAvailability(item) {
  var _item$shopify_variant;
  var qtyTotal = parseInt(item.quantity_total, 10);
  if (qtyTotal > 0) return true;
  if ((_item$shopify_variant = item.shopify_variants) !== null && _item$shopify_variant !== void 0 && _item$shopify_variant.length) {
    return item.shopify_variants.some(function (variant) {
      return String(variant.available) === '1';
    });
  }
  return false;
};

/**
 * Labels + back-in-stock tag exposed by searchanise-badge-config.liquid (window.PRFO_SEARCHANISE_LABELS).
 * Falls back to English so a missing snippet never breaks badge rendering.
 */
var getLabels = function getLabels() {
  var labels = window.PRFO_SEARCHANISE_LABELS || {};
  return {
    backInStockTag: String(labels.back_in_stock_tag || '').trim(),
    soldOut: labels.sold_out || 'Sold Out',
    comingSoon: labels.coming_soon || 'Coming Soon'
  };
};

/**
 * Parses Searchanise item tags: a "[:ATTR:]"-joined string (Searchanise API format) or an array.
 * Returns trimmed, lowercased tags.
 */
var getItemTags = function getItemTags(item) {
  var raw = item ? item.tags : null;
  if (!raw) return [];
  var list = Array.isArray(raw) ? raw : String(raw).split('[:ATTR:]');
  return list.map(function (tag) {
    return String(tag).trim().toLowerCase();
  }).filter(Boolean);
};

/**
 * Case-insensitive exact tag match (Shopify tags are case-insensitive). Blank tag never matches —
 * mirrors `back_in_stock_tag != blank` in product-thumbnail__sticker.liquid.
 */
var hasTag = function hasTag(item, tag) {
  var needle = String(tag || '').trim().toLowerCase();
  if (!needle) return false;
  return getItemTags(item).indexOf(needle) !== -1;
};

/**
 * Builds base product data (sale/sold-out/coming-soon badges) from Searchanise items.
 * The sale badge follows the variant-aware summary built by searchanise-update-data
 * (window.PFRO_PriceInfo): the discount of the pool that is actually purchasable.
 * Items without such a summary (no variants / no variant prices) keep the legacy
 * top-level price computation. Metaobject badges are resolved at render time from the DOM.
 */
var buildProductsData = function buildProductsData(items) {
  if (!(items !== null && items !== void 0 && items.length)) return;
  var labels = getLabels();
  window.SEARCHANISE_PRODUCTS_DATA = items.map(function (item) {
    var handle = extractHandle(item.link);
    var available = checkProductAvailability(item);
    var badges = [];

    // Sale badge
    var info = window.PFRO_PriceInfo && window.PFRO_PriceInfo[item.product_id];
    var summary = info ? info.all : null;
    if (summary) {
      if (available && summary.onSale && summary.percent > 0) {
        badges.push({
          type: 'sale',
          text: '-' + summary.percent + '%'
        });
      }
    } else {
      var price = parseFloat(item.price);
      var listPrice = parseFloat(item.list_price);
      var discount = parseInt(item.discount, 10) || 0;
      if (available && listPrice > 0 && listPrice > price) {
        var percent = discount > 0 ? discount : Math.round((listPrice - price) / listPrice * 100);
        badges.push({
          type: 'sale',
          text: "-".concat(percent, "%")
        });
      }
    }

    // Sold out / Coming soon badge.
    // Coming soon = unavailable AND tagged with the theme's back-in-stock tag (settings.back_in_stock_tag,
    // "NOTIFYME"); mirrors snippets/product-thumbnail__sticker.liquid for native cards.
    var comingSoon = false;
    if (!available) {
      comingSoon = hasTag(item, labels.backInStockTag);
      badges.push(comingSoon ? {
        type: 'coming-soon',
        text: labels.comingSoon
      } : {
        type: 'sold-out',
        text: labels.soldOut
      });
    }
    return {
      product_id: item.product_id,
      handle: handle,
      vendor: item.vendor,
      available: available,
      coming_soon: comingSoon,
      badges: badges
    };
  });

  // O(1) lookup for updateSaleBadge (single card re-render after a colour switch).
  // Merged, not replaced: an autocomplete payload fires the same event and must not drop the
  // entries of the results page whose cards are still on screen.
  window.SEARCHANISE_PRODUCTS_MAP = window.SEARCHANISE_PRODUCTS_DATA.reduce(function (acc, product) {
    acc[product.product_id] = product;
    return acc;
  }, window.SEARCHANISE_PRODUCTS_MAP || {});
  renderBadges();
};

/**
 * Extracts product handle from Searchanise item link.
 */
var extractHandle = function extractHandle(link) {
  var _match$;
  if (!link) return null;
  var match = link.match(/\/products\/([^?#/]+)/);
  return (_match$ = match === null || match === void 0 ? void 0 : match[1]) !== null && _match$ !== void 0 ? _match$ : null;
};

/**
 * Converts a collection title to a URL handle (slug).
 * Fallback for collections not covered by PRFO_COLLECTION_HANDLE_MAP.
 */
var titleToHandle = function titleToHandle(title) {
  return title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
};

/**
 * Builds a reverse lookup from the Liquid-rendered PRFO_COLLECTION_HANDLE_MAP.
 *
 * PRFO_COLLECTION_HANDLE_MAP (from searchanise-badge-config.liquid):
 *   { "new-arrivals": "new arrivals", "badge-winter-2025-26-126": "winter 2025-26" }
 *
 * Reversed result:
 *   { "new arrivals": "new-arrivals", "winter 2025-26": "badge-winter-2025-26-126" }
 *
 * This lets renderBadges resolve Searchanise's English collection titles back to
 * their canonical handles, even when the handle was never derived from the title.
 */
var buildTitleHandleMap = function buildTitleHandleMap() {
  var raw = window.PRFO_COLLECTION_HANDLE_MAP || {};
  return Object.fromEntries(Object.entries(raw).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      handle = _ref2[0],
      title = _ref2[1];
    return [title, handle];
  }));
};

/**
 * Markup of the "-N%" sale sticker (identical to the theme's native thumbnail sticker).
 * @param {string} text - sticker text, e.g. "-30%"
 * @returns {string} HTML
 */
var saleStickerHTML = function saleStickerHTML(text) {
  return "<div class=\"thumbnail-sticker thumbnail-sticker--sale\" style=\"padding: 6px 8px;\">\n          <span class=\"thumbnail-sticker__text\" style=\"font-size: 11px;\">".concat(text, "</span>\n        </div>");
};

/**
 * Markup of the sticker holder that wraps all badges of one card.
 * @param {Object} product - SEARCHANISE_PRODUCTS_DATA entry
 * @param {string} badgesHTML - concatenated badge markup
 * @returns {string} HTML
 */
var holderHTML = function holderHTML(product, badgesHTML) {
  return "\n      <div class=\"sticker-holder\">\n        <div class=\"sticker-holder__content sticker-holder__content--thumbnail\">\n          <div class=\"new_badges\" data-handle=\"".concat(product.handle, "\">\n            ").concat(badgesHTML, "\n          </div>\n        </div>\n      </div>\n    ");
};

/**
 * Renders badges into Searchanise product cards.
 * Sale/sold-out/coming-soon badges come from SEARCHANISE_PRODUCTS_DATA.
 * Metaobject badges are resolved from .snize-attribute (collection titles in DOM).
 *
 * Matching priority per badge:
 *  1. collection_titles — exact lowercase match (locale-aware)
 *  2. collection_handles via reverse PRFO_COLLECTION_HANDLE_MAP — authoritative:
 *     resolves English titles to handles regardless of locale or renames
 *  3. collection_handles via titleToHandle — slug-derivation fallback
 */
var renderBadges = function renderBadges() {
  var data = window.SEARCHANISE_PRODUCTS_DATA;
  if (!(data !== null && data !== void 0 && data.length)) return;
  var badgeConfig = window.PRFO_BADGE_CONFIG || [];
  var productCards = document.querySelectorAll('.snize-product[data-original-product-id]');
  if (!productCards.length) return;

  // Build lookup by product_id
  var dataMap = data.reduce(function (acc, item) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, item.product_id, item));
  }, {});

  // Reverse of PRFO_COLLECTION_HANDLE_MAP: lowercased English title → canonical handle.
  // Computed once per renderBadges call and reused across all product cards.
  var titleHandleMap = buildTitleHandleMap();
  var labels = getLabels();
  productCards.forEach(function (card) {
    var productId = card.getAttribute('data-original-product-id');
    var product = dataMap[productId];
    if (!product) return;
    var wrapper = card.querySelector('.snize-thumbnail-wrapper');
    if (!wrapper) return;

    // Skip if already rendered
    if (wrapper.querySelector('.sticker-holder__content')) return;

    // Start with sale/sold-out badges from data
    var allBadges = _toConsumableArray(product.badges || []);

    // Fallback signal: the Searchanise widget stamps every product tag on the card as a class
    // (snize-product-tag-<tag>, normalised below exactly like the widget's ${product_classes}).
    // If the item payload did not mark the product as coming soon but the card carries the
    // back-in-stock tag class, still show Coming Soon instead of Sold Out.
    if (labels.backInStockTag && !product.coming_soon && card.classList) {
      var normalizedTag = labels.backInStockTag.replace(/ /g, '-').replace(/[^a-z0-9A-Z_-]/g, '').replace(/^-*[0-9]+/g, '').toLowerCase();
      if (normalizedTag && card.classList.contains('snize-product-tag-' + normalizedTag)) {
        allBadges = allBadges.map(function (badge) {
          return badge.type === 'sold-out' ? {
            type: 'coming-soon',
            text: labels.comingSoon
          } : badge;
        });
      }
    }

    // Resolve metaobject badges from .snize-attribute collection titles
    if (badgeConfig.length > 0) {
      var attrEl = card.querySelector('.snize-attribute');
      if (attrEl) {
        var productCollections = attrEl.textContent.split(',').map(function (s) {
          return s.trim().toLowerCase();
        }).filter(Boolean);

        // Resolve each Searchanise English title to its canonical handle.
        // Authoritative Liquid map is checked first; slug derivation is the fallback.
        var productCollectionHandles = productCollections.map(function (title) {
          return titleHandleMap[title] || titleToHandle(title);
        });
        badgeConfig.forEach(function (badge) {
          var titles = (badge.collection_titles || []).map(function (t) {
            return t.toLowerCase();
          });
          var handles = (badge.collection_handles || []).map(function (h) {
            return h.toLowerCase();
          });
          var inCollection =
          // 1. Exact locale-aware title match
          titles.some(function (t) {
            return productCollections.includes(t);
          }) ||
          // 2. Canonical handle match (Liquid map + slug fallback)
          handles.some(function (h) {
            return productCollectionHandles.includes(h);
          });
          if (inCollection) {
            allBadges.unshift({
              type: 'metaobject',
              text: badge.text || '',
              text_color: badge.text_color || '#000',
              bg_color: badge.bg_color || '#fff',
              svg_url: badge.svg_url || ''
            });
          }
        });
      }
    }
    if (!allBadges.length) return;
    var badgesHTML = allBadges.map(function (badge) {
      if (badge.type === 'sale') {
        return saleStickerHTML(badge.text);
      }
      if (badge.type === 'sold-out') {
        return "<div class=\"thumbnail-sticker thumbnail-sticker--sold-out\" style=\"padding: 6px 8px;\">\n          <span class=\"thumbnail-sticker__text\" style=\"font-size: 11px;\">".concat(badge.text, "</span>\n        </div>");
      }
      if (badge.type === 'coming-soon') {
        return "<div class=\"thumbnail-sticker thumbnail-sticker--coming-soon\" style=\"padding: 6px 8px;\">\n          <span class=\"thumbnail-sticker__text\" style=\"font-size: 11px;\">".concat(badge.text, "</span>\n        </div>");
      }
      if (badge.type === 'metaobject') {
        if (badge.svg_url) {
          return "<div class=\"new_badges--img\" style=\"max-width: 60px; margin-bottom: 5px;\">\n            <img src=\"".concat(badge.svg_url, "\" alt=\"").concat(badge.text, "\" style=\"width: 100%; height: auto;\" loading=\"lazy\">\n          </div>");
        }
        if (badge.text) {
          return "<p class=\"new_badges--text\" style=\"color:".concat(badge.text_color, "; background-color:").concat(badge.bg_color, "; padding: 6px 8px; font-size: 11px;\">\n            ").concat(badge.text, "\n          </p>");
        }
      }
      return '';
    }).join('');
    if (!badgesHTML) return;
    wrapper.insertAdjacentHTML('beforeend', holderHTML(product, badgesHTML));
  });
};

/**
 * Re-renders the sale sticker of ONE card after the customer switched colour on it.
 * Adds, updates or removes only the "-N%" sticker; metaobject, sold-out and coming-soon
 * badges are left exactly as renderBadges produced them.
 * @param {Element} card - li.snize-product
 * @param {Object|null} summary - PFRO_PriceUtils summary of the selected pool
 */
var updateSaleBadge = function updateSaleBadge(card, summary) {
  if (!card || typeof card.querySelector !== 'function') return;
  var wrapper = card.querySelector('.snize-thumbnail-wrapper');
  if (!wrapper) return;
  var productId = card.getAttribute('data-original-product-id');
  var product = (window.SEARCHANISE_PRODUCTS_MAP || {})[productId];
  var want = !!(product && product.available && summary && summary.onSale && summary.percent > 0);
  var existing = wrapper.querySelector('.thumbnail-sticker--sale');
  if (want) {
    var text = '-' + summary.percent + '%';
    if (existing) {
      var textEl = existing.querySelector('.thumbnail-sticker__text');
      if (textEl) textEl.textContent = text;
      return;
    }
    var badgesBox = wrapper.querySelector('.new_badges');
    if (!badgesBox) {
      if (!product) return;
      wrapper.insertAdjacentHTML('beforeend', holderHTML(product, saleStickerHTML(text)));
      return;
    }
    // Keep the metaobject badges first and the sale sticker above sold-out/coming-soon
    var firstSticker = badgesBox.querySelector('.thumbnail-sticker');
    if (firstSticker) {
      firstSticker.insertAdjacentHTML('beforebegin', saleStickerHTML(text));
    } else {
      badgesBox.insertAdjacentHTML('beforeend', saleStickerHTML(text));
    }
    return;
  }
  if (existing) {
    if (existing.parentNode) existing.parentNode.removeChild(existing);
    var box = wrapper.querySelector('.new_badges');
    if (box && !box.children.length) {
      var holder = wrapper.querySelector('.sticker-holder');
      if (holder && holder.parentNode) holder.parentNode.removeChild(holder);
    }
  }
};
window.PFRO_updateSaleBadge = updateSaleBadge;

/**
 * Updates product cards: puts vendor in .snize-title and product title in .snize-description.
 * Uses SEARCHANISE_CURRENT_ITEMS matched by data-original-product-id.
 */
var updateProductInfo = function updateProductInfo() {
  var items = window.SEARCHANISE_CURRENT_ITEMS;
  if (!(items !== null && items !== void 0 && items.length)) return;

  // Build lookup by product_id
  var itemMap = items.reduce(function (acc, item) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, item.product_id, item));
  }, {});
  var productCards = document.querySelectorAll('.snize-product[data-original-product-id]');
  productCards.forEach(function (card) {
    var productId = card.getAttribute('data-original-product-id');
    var item = itemMap[productId];
    if (!item) return;
    var titleEl = card.querySelector('.snize-title');
    var descEl = card.querySelector('.snize-description');
    if (titleEl) titleEl.textContent = item.vendor;
    if (descEl) descEl.textContent = item.title;
  });
};

/***/ },

/***/ "./src/scripts/collections/searchanise/searchanise-banner.js"
/*!*******************************************************************!*\
  !*** ./src/scripts/collections/searchanise/searchanise-banner.js ***!
  \*******************************************************************/
() {

function _initBanner() {
  var $ = window.Searchanise.$;
  $(document).on('Searchanise.ResultsUpdated', function (event, container) {
    // A throw here would starve the later handlers (jQuery stops the dispatch), among them the
    // card price render.
    try {
      injectCollectionBanner();
    } catch (e) {
      // let the later handlers run
    }
  });
}
if (window.Searchanise && window.Searchanise.$) {
  _initBanner();
} else {
  document.addEventListener('Searchanise.Loaded', _initBanner);
}

/**
 * Injects the collection promotional banner into Searchanise results.
 * Reads configuration from window.PRFO_COLLECTION_BANNER (set by Liquid snippet).
 * Places the banner above the product grid inside #snize_results.
 */
function injectCollectionBanner() {
  var config = window.PRFO_COLLECTION_BANNER;
  if (!config || !config.image_url) return;
  var resultsContainer = document.getElementById('snize_results');
  if (!resultsContainer) return;

  // Skip if already injected
  if (resultsContainer.querySelector('.searchanise-collection-banner')) return;

  // Find the product list container (parent of product cards)
  var firstProduct = resultsContainer.querySelector('.snize-product');
  if (!firstProduct) return;
  var productList = firstProduct.parentElement;
  if (!productList) return;

  // Build banner element
  var banner = document.createElement('div');
  banner.className = 'searchanise-collection-banner collection__banner-wrapper';
  var img = document.createElement('img');
  img.src = config.image_url;
  img.alt = config.image_alt || '';
  img.loading = 'lazy';
  if (config.link) {
    var link = document.createElement('a');
    link.href = config.link;
    link.appendChild(img);
    banner.appendChild(link);
  } else {
    banner.appendChild(img);
  }

  // Insert before the product list
  productList.parentElement.insertBefore(banner, productList);
}

/***/ },

/***/ "./src/scripts/collections/searchanise/searchanise-card-product-customizations.js"
/*!****************************************************************************************!*\
  !*** ./src/scripts/collections/searchanise/searchanise-card-product-customizations.js ***!
  \****************************************************************************************/
() {

function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var _initCardProductCustomizations = function _initCardProductCustomizations() {
  var $ = window.Searchanise.$;
  $(document).on('Searchanise.ResultsUpdated', function (event, container) {
    // The widget rewrites every price list right after this event (see observePriceLists):
    // watch the (possibly brand-new) results container before anything is rendered into it.
    try {
      observePriceLists(container);
    } catch (e) {
      // the render below still runs
    }
    // Isolated: a throw in the swatch rebuild must not stop the price render and vice versa.
    try {
      showOnlyColorSwatches();
    } catch (e) {
      // keep going with the price render
    }
    try {
      renderCardPrices(container);
    } catch (e) {
      // swatches are already rendered
    }
  });
};
if (window.Searchanise && window.Searchanise.$) {
  _initCardProductCustomizations();
} else {
  document.addEventListener('Searchanise.Loaded', _initCardProductCustomizations);
}
var showOnlyColorSwatches = function showOnlyColorSwatches() {
  var productsWithColorVariants = window.PFRO_ColorsVariants || [];
  if (!productsWithColorVariants.length) return;
  productsWithColorVariants.forEach(function (colorData) {
    // Only proceed if the product actually has more than 1 color variant
    if (colorData && colorData.colors && colorData.colors.length > 1) {
      // Find the specific product element in the DOM by its ID
      var productEl = document.getElementById("snize-product-".concat(colorData.product_id));
      if (productEl) {
        var originalOptionsBox = productEl.querySelector('.snize-options-box:not(.pfro-custom-options-box)');
        if (originalOptionsBox) {
          // Hide the original options box so Searchanise can modify it in the background without affecting UI
          originalOptionsBox.style.display = 'none';
        }
        var customOptionsBox = productEl.querySelector('.pfro-custom-options-box');

        // Sort colors: available first, unavailable last
        var sortedColors = _toConsumableArray(colorData.colors).sort(function (a, b) {
          if (a.available === b.available) return 0;
          return a.available ? -1 : 1;
        });

        // Generate the inner HTML for the swatches
        var swatchesInnerHtml = '';
        var availableData = window.PFRO_FirstAvailableVariants && window.PFRO_FirstAvailableVariants[colorData.product_id];
        var defaultColorName = availableData ? availableData.color : colorData.firstAvailableColor;
        var availableColors = sortedColors.filter(function (c) {
          return c.available;
        });

        // Find the matching color robustly (case-insensitive or by matching the image URL)
        var defaultColor = availableColors.find(function (c) {
          if (c.color && defaultColorName && c.color.toLowerCase() === defaultColorName.toLowerCase()) return true;
          if (availableData && availableData.image_link && c.image && c.image.includes(availableData.image_link.split('?')[0])) return true;
          return false;
        }) || availableColors[0] || sortedColors[0];
        swatchesInnerHtml += "\n          <input type=\"hidden\" name=\"Color\" value=\"".concat(defaultColor.color, "\" class=\"snize-option snize-option-color\">\n          <span class=\"snize-visually-hidden variant-live-status\" aria-live=\"polite\">Color: ").concat(defaultColor.color, " selected</span>\n        ");
        availableColors.forEach(function (colorItem, index) {
          var isActive = colorItem.color === defaultColor.color;
          var bgImage = colorItem.image ? "background-image: url('".concat(colorItem.image, "');") : '';
          var bgColor = colorItem.color_code ? "background-color: #".concat(colorItem.color_code.replace('#', ''), ";") : '';
          swatchesInnerHtml += "\n            <div tabindex=\"".concat(isActive ? '0' : '-1', "\" role=\"radio\" aria-checked=\"").concat(isActive ? 'true' : 'false', "\" aria-label=\"Color: ").concat(colorItem.color, "\" class=\"pfro-color-swatch ").concat(isActive ? 'pfro-color-swatch-active' : '', "\" data-value=\"").concat(colorItem.color, "\" data-image=\"").concat(colorItem.image || '', "\" title=\"").concat(colorItem.color, "\">\n                <span class=\"\" style=\"").concat(bgColor, " ").concat(bgImage, "\"></span>\n            </div>\n          ");
        });
        if (!customOptionsBox) {
          customOptionsBox = document.createElement('div');
          // Add snize-options-box so CSS rules still apply, but add our custom class to distinguish it
          customOptionsBox.className = 'snize-options-box pfro-custom-options-box';
          if (originalOptionsBox) {
            originalOptionsBox.parentNode.insertBefore(customOptionsBox, originalOptionsBox.nextSibling);
          } else {
            var priceList = productEl.querySelector('.snize-price-list');
            if (priceList) {
              priceList.parentNode.insertBefore(customOptionsBox, priceList);
            } else {
              var overhidden = productEl.querySelector('.snize-overhidden');
              if (overhidden) {
                overhidden.appendChild(customOptionsBox);
              }
            }
          }
        }
        var swatchesHtml = "<div aria-label=\"Select color\" role=\"radiogroup\" class=\"snize-color-swatch-box snize-option-count-".concat(availableColors.length, " snize-shape-square snize-swatch-type-image\">");
        swatchesHtml += swatchesInnerHtml;
        swatchesHtml += "</div><div class=\"snize-simple-options-box snize-unmapped-colors-box\"></div><div class=\"snize-simple-options-box\"></div>";
        customOptionsBox.innerHTML = swatchesHtml;

        // The swatch box was rebuilt with the default colour highlighted, so the price must
        // fall back to the whole-pool summary until the customer picks a colour again.
        productEl.removeAttribute('data-pfro-selected-color');

        // Explicitly enforce the active class on the DOM element just to be 100% sure
        var allSwatches = customOptionsBox.querySelectorAll('.pfro-color-swatch');
        allSwatches.forEach(function (sw) {
          return sw.classList.remove('pfro-color-swatch-active');
        });
        var targetSwatch = customOptionsBox.querySelector(".pfro-color-swatch[data-value=\"".concat(defaultColor.color, "\"]"));
        if (targetSwatch) {
          targetSwatch.classList.add('pfro-color-swatch-active');
          targetSwatch.setAttribute('aria-checked', 'true');
        }
        bindSwatchEvents(customOptionsBox, productEl);

        // Update the native original options box silently to keep Add to Cart working
        if (originalOptionsBox) {
          var selectBoxes = originalOptionsBox.querySelectorAll('.snize-option-selector-wrapper');
          selectBoxes.forEach(function (box) {
            var select = box.querySelector('select');
            if (select && select.name === 'Color') {
              if (select.value !== defaultColor.color) {
                select.value = defaultColor.color;
              }
            }
          });
        }

        // Synchronously force DOM sync with Searchanise core state
        if (availableData) {
          var currentVariant = productEl.getAttribute('data-product-variant');
          if (currentVariant != availableData.variant_id) {
            productEl.setAttribute('data-product-variant', availableData.variant_id);
          }
          if (availableData.image_link) {
            var originalImg = productEl.querySelector('img.snize-item-image:not(.pfro-custom-image)');
            if (originalImg) {
              // Hide the original image so Searchanise can modify it in the background without affecting UI
              originalImg.style.display = 'none';
              var customImg = productEl.querySelector('img.pfro-custom-image');
              if (!customImg) {
                customImg = document.createElement('img');
                // Omit 'snize-item-image' class so Searchanise ignores this node
                customImg.className = originalImg.className.replace('snize-item-image', '').trim() + ' pfro-custom-image';
                customImg.style.display = 'block';
                customImg.style.width = '100%';
                customImg.style.objectFit = 'contain';
                if (originalImg.alt) customImg.alt = originalImg.alt;
                originalImg.parentNode.insertBefore(customImg, originalImg.nextSibling);
              }
              if (!customImg.src.includes(availableData.image_link.split('?')[0])) {
                customImg.src = availableData.image_link;
                customImg.srcset = '';
              }
            }
          }

          // Silently update native hidden Searchanise selects so Add to Cart works properly
          if (availableData && availableData.color) {
            var selects = productEl.querySelectorAll('select.snize-option');
            selects.forEach(function (select) {
              if (select.name === 'Color' && select.value !== availableData.color) {
                select.value = availableData.color;
                // We do NOT dispatch 'change' here anymore, because that triggers Searchanise's rebuildProductVariant,
                // which completely overwrites our custom DOM injection and breaks the swatches again!
              }
            });
          }
        }
      }
    }
  });
};
/**
 * Renders the variant-aware price of ONE card from window.PFRO_PriceInfo:
 * the whole available pool by default, the selected colour's pool after a swatch click.
 * Cards without price info (item had no usable variants, or nothing is available) keep the
 * widget's own output.
 * @param {Element} productEl - li.snize-product
 * @returns {Object|null} the summary the card was rendered from, null when nothing was rendered
 */
var renderCardPrice = function renderCardPrice(productEl) {
  if (!productEl || typeof productEl.querySelector !== 'function') return null;
  var utils = window.PFRO_PriceUtils;
  if (!utils) return null;
  var id = productEl.getAttribute('data-original-product-id');
  var info = window.PFRO_PriceInfo && window.PFRO_PriceInfo[id];
  if (!info) return null;
  var priceList = productEl.querySelector('.snize-price-list');
  if (!priceList) return null;
  var color = productEl.getAttribute('data-pfro-selected-color');
  var summary = color && info.byColor && info.byColor[color] ? info.byColor[color] : info.all;
  if (!summary) return null;
  var text = utils.priceText(summary);
  var showCompare = !!summary.showCompare;
  var key = id + '|' + (color || '') + '|' + text + '|' + (showCompare ? summary.listPrice : '');

  // Re-render unless the container still holds exactly the markup this key describes
  if (priceList.getAttribute('data-pfro-price-key') === key && priceList.querySelector('.snize-price[data-pfro-price]')) return summary;
  var priceClass = 'snize-price';
  if (showCompare) priceClass += ' snize-price-with-discount';
  if (summary.showRange) priceClass += ' pfro-price-range';
  priceClass += ' money ';
  var html = '<span class="' + priceClass + '" data-pfro-price="1">' + text + '<span class="snize-highlight-saving-text"></span></span>';
  if (showCompare) {
    html += '<span class="snize-visually-hidden">Old price</span><span class="snize-discounted-price money ">' + utils.formatMoney(summary.listPrice) + '</span><span class="snize-save-price-wrapper"></span>';
  }
  var unitPrice = priceList.querySelector('.snize-unit-price');
  if (unitPrice) html += unitPrice.outerHTML;
  priceList.innerHTML = html;
  priceList.setAttribute('data-pfro-price-key', key);
  return summary;
};

/**
 * True for the cards of the autocomplete dropdown, which this module never touches.
 * @param {Element} card - li.snize-product candidate
 * @returns {boolean}
 */
var isAutocompleteCard = function isAutocompleteCard(card) {
  var id = card.getAttribute('id') || '';
  if (id.indexOf('snize-ac-') === 0) return true;
  return card.classList.contains('snize-ac-odd') || card.classList.contains('snize-ac-even');
};

/**
 * Renders the variant-aware price on every card of the current results page and keeps the
 * "-N%" sticker in sync with the very summary the price was rendered from (a card whose DOM
 * survived a colour click gets its whole-pool sticker back).
 * One broken card must never stop the loop.
 * @param {Element} [container] - the results container passed by Searchanise.ResultsUpdated
 */
var renderCardPrices = function renderCardPrices(container) {
  var root = container && typeof container.querySelectorAll === 'function' ? container : document.getElementById('snize_results') || document;
  var productCards = root.querySelectorAll('.snize-product[data-original-product-id]');
  if (!productCards || !productCards.length) return;
  productCards.forEach(function (card) {
    try {
      if (isAutocompleteCard(card)) return;
      var summary = renderCardPrice(card);
      if (summary && typeof window.PFRO_updateSaleBadge === 'function') {
        window.PFRO_updateSaleBadge(card, summary);
      }
    } catch (e) {
      // keep rendering the remaining cards
    }
  });
};

/**
 * Re-renders every card whose price list no longer carries our markup.
 *
 * The widget overwrites `.snize-price-list` AFTER Searchanise.ResultsUpdated: with
 * ResultsShowOptionVariants = 'Y' its results module (snize-search-results.*.min.js) runs
 * rebuildProductVariant() on every card of the page as soon as the event handlers return, and
 * that method replaces the price markup through jQuery .html() with the price of the variant
 * picked by selectVariantByPriceSource (the widget's own option selectors trigger the same
 * rebuild). Whatever renderCardPrices() painted in the ResultsUpdated handler is therefore gone a
 * few milliseconds later. This observer callback brings it back: it runs as a microtask, i.e.
 * after the widget's synchronous rebuild and before the next paint, so the widget's markup is
 * never displayed. Our own writes carry data-pfro-price and are skipped (no feedback loop).
 * @param {MutationRecord[]} records
 */
var restoreCardPrices = function restoreCardPrices(records) {
  var seen = [];
  for (var i = 0; i < records.length; i++) {
    var target = records[i].target;
    if (!target || target.nodeType !== 1 || typeof target.closest !== 'function') continue;
    var priceList = target.closest('.snize-price-list');
    if (!priceList || seen.indexOf(priceList) !== -1) continue;
    seen.push(priceList);
    if (priceList.querySelector('.snize-price[data-pfro-price]')) continue;
    var card = priceList.closest('.snize-product[data-original-product-id]');
    if (!card || isAutocompleteCard(card)) continue;
    try {
      var summary = renderCardPrice(card);
      if (summary && typeof window.PFRO_updateSaleBadge === 'function') {
        window.PFRO_updateSaleBadge(card, summary);
      }
    } catch (e) {
      // keep restoring the remaining cards
    }
  }
};
var priceObserver = null;
var observedResults = null;

/**
 * Watches the results container for price lists rewritten by the widget (restoreCardPrices).
 * The widget swaps in its rendered container on the first render (t.replaceWith(z), guarded by
 * document.contains) and reuses it afterwards; this runs on each ResultsUpdated anyway and
 * re-attaches whenever the element changed, so a future widget build that re-creates the
 * container is covered too. The autocomplete dropdown lives outside #snize_results and is
 * never watched.
 * @param {Element|jQuery} [container] - the container passed by Searchanise.ResultsUpdated
 */
var observePriceLists = function observePriceLists(container) {
  if (typeof MutationObserver !== 'function') return;
  var results = document.getElementById('snize_results');
  if (!results && container) results = typeof container.querySelectorAll === 'function' ? container : container[0];
  if (!results || results.nodeType !== 1 || results === observedResults) return;
  if (!priceObserver) priceObserver = new MutationObserver(restoreCardPrices);else priceObserver.disconnect();
  priceObserver.observe(results, {
    childList: true,
    subtree: true
  });
  observedResults = results;
};
var bindSwatchEvents = function bindSwatchEvents(container, productEl) {
  var swatches = container.querySelectorAll('.pfro-color-swatch');
  swatches.forEach(function (swatch) {
    swatch.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var imageUrl = swatch.getAttribute('data-image');
      if (imageUrl) {
        var customImg = productEl.querySelector('img.pfro-custom-image');
        var originalImg = productEl.querySelector('img.snize-item-image:not(.pfro-custom-image)');

        // Update our custom image if it exists, otherwise fallback to the original
        if (customImg) {
          customImg.src = imageUrl;
          customImg.srcset = ''; // Clear srcset so src takes precedence
        } else if (originalImg) {
          originalImg.src = imageUrl;
          originalImg.srcset = '';
        }
      }
      var swatchContainer = swatch.closest('.snize-color-swatch-box');
      if (swatchContainer) {
        // Reset all swatches
        swatchContainer.querySelectorAll('.pfro-color-swatch').forEach(function (el) {
          el.classList.remove('pfro-color-swatch-active');
          el.setAttribute('aria-checked', 'false');
        });

        // Set clicked swatch as active
        swatch.classList.add('pfro-color-swatch-active');
        swatch.setAttribute('aria-checked', 'true');
        var hiddenInput = swatchContainer.querySelector('.pfro-option-color');
        if (hiddenInput) {
          hiddenInput.value = swatch.getAttribute('data-value');
        }
        var liveStatus = swatchContainer.querySelector('.variant-live-status');
        if (liveStatus) {
          liveStatus.textContent = "Color: ".concat(swatch.getAttribute('data-value'), " selected");
        }

        // Keep native hidden selects in sync so Add to Cart continues to work
        var originalOptionsBox = productEl.querySelector('.snize-options-box:not(.pfro-custom-options-box)');
        if (originalOptionsBox) {
          var selectBoxes = originalOptionsBox.querySelectorAll('.snize-option-selector-wrapper');
          selectBoxes.forEach(function (box) {
            var select = box.querySelector('select');
            if (select && select.name === 'Color') {
              select.value = swatch.getAttribute('data-value');
            }
          });
        }
      }

      // Price and sale sticker follow the selected colour
      var selectedColor = swatch.getAttribute('data-value');
      productEl.setAttribute('data-pfro-selected-color', selectedColor);
      renderCardPrice(productEl);
      var info = window.PFRO_PriceInfo && window.PFRO_PriceInfo[productEl.getAttribute('data-original-product-id')];

      // No price info -> legacy card: neither the price nor its badges are ours to touch
      if (info && typeof window.PFRO_updateSaleBadge === 'function') {
        var summary = info.byColor && info.byColor[selectedColor] ? info.byColor[selectedColor] : info.all;
        window.PFRO_updateSaleBadge(productEl, summary);
      }
    });
  });
};

/***/ },

/***/ "./src/scripts/collections/searchanise/searchanise-category-filter.js"
/*!****************************************************************************!*\
  !*** ./src/scripts/collections/searchanise/searchanise-category-filter.js ***!
  \****************************************************************************/
() {

function _initCategoryFilter() {
  var $ = window.Searchanise.$;
  $(document).on('Searchanise.ResultsUpdated', function (event, container) {
    var handle = window.PRFO_CURRENT_COLLECTION_HANDLE;
    var menuData = getShopifyMenuData();
    var activePath = handle ? findCollectionPathInMenu(handle, menuData) : null;
    if (activePath) {
      // If the collection is in the menu, we use the new Shopify Links filter
      transformCategoryFilterShopify(activePath, menuData);
      transformMobileCategoryFilterShopify(activePath, menuData);
    } else {
      // If not, we use the original logic to convert checkboxes into a tree
      transformCategoryFilterSearchanise();
      transformMobileCategoryFilterSearchanise();
    }
  });
}
if (window.Searchanise && window.Searchanise.$) {
  _initCategoryFilter();
} else {
  document.addEventListener('Searchanise.Loaded', _initCategoryFilter);
}

// ==========================================
// 1. UTILITIES AND DATA FETCHING
// ==========================================
function getShopifyMenuData() {
  var el = document.getElementById('shopify-menu-data');
  if (el) {
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.error('Failed to parse shopify-menu-data', e);
    }
  }
  return [];
}
function findCollectionPathInMenu(handle, menuNodes, currentPath) {
  if (!menuNodes || !menuNodes.length) return null;
  currentPath = currentPath || [];
  for (var i = 0; i < menuNodes.length; i++) {
    var node = menuNodes[i];
    var path = currentPath.concat([node]);
    if (node.handle === handle) {
      return path;
    }
    if (node.links && node.links.length > 0) {
      var found = findCollectionPathInMenu(handle, node.links, path);
      if (found) return found;
    }
  }
  return null;
}

// ==========================================
// 2. MODE: NEW SHOPIFY MENU (CANONICAL LINKS)
// ==========================================
function transformCategoryFilterShopify(activePath, menuData) {
  var categoryBlock = document.querySelector('.snize-product-filters-block [data-se-facet-default-title="Category"]');
  if (!categoryBlock) return;
  var filterBlock = categoryBlock.closest('.snize-product-filters-block');
  if (!filterBlock) return;
  buildShopifyMenuCategoryTree(filterBlock, activePath, menuData);
}
function transformMobileCategoryFilterShopify(activePath, menuData) {
  var mobileDialog = document.getElementById('snize-modal-mobile-filters-dialog');
  if (!mobileDialog) return;
  var firstCatCb = mobileDialog.querySelector('.snize-product-filters-checkbox[data-se-facet-default-title="Category"]');
  if (!firstCatCb) return;
  var filterContainer = firstCatCb.closest('.snize-product-filter-container');
  if (!filterContainer) return;
  buildShopifyMenuCategoryTree(filterContainer, activePath, menuData);
}
function buildUrlWithSearch(url, currentSearch) {
  if (!currentSearch) return url;
  if (url.indexOf('?') === -1) {
    return url + currentSearch;
  } else {
    return url + '&' + currentSearch.substring(1);
  }
}
function buildShopifyMenuCategoryTree(container, activePath, menuData) {
  var originalList = container.querySelector('.snize-product-filters-list');
  if (!originalList) return;
  var oldTree = container.querySelector('.snize-category-tree');
  if (oldTree) oldTree.remove();
  var treeEl = document.createElement('ul');
  treeEl.className = 'contextual-category-tree snize-category-tree';
  var currentSearch = window.location.search;
  if (activePath.length > 1) {
    var parentNode = activePath[activePath.length - 2];
    if (parentNode.count > 0) {
      var parentLi = document.createElement('li');
      parentLi.className = 'tree-item is-parent';
      var parentLink = document.createElement('a');
      parentLink.href = buildUrlWithSearch(parentNode.url, currentSearch);
      parentLink.innerHTML = '&laquo; ' + parentNode.title;
      parentLi.appendChild(parentLink);
      treeEl.appendChild(parentLi);
    }
  }
  var currentNode = activePath[activePath.length - 1];
  if (currentNode.count > 0) {
    var currentLi = document.createElement('li');
    currentLi.className = 'tree-item is-current';
    var currentSpan = document.createElement('span');
    currentSpan.textContent = currentNode.title + ' ';
    var currentCountSpan = document.createElement('span');
    currentCountSpan.className = 'item-count';
    currentCountSpan.textContent = '(' + currentNode.count + ')';
    currentSpan.appendChild(currentCountSpan);
    currentLi.appendChild(currentSpan);
    treeEl.appendChild(currentLi);
  }
  if (currentNode.links && currentNode.links.length > 0) {
    currentNode.links.forEach(function (childNode) {
      if (childNode.count > 0) {
        var childLi = document.createElement('li');
        childLi.className = 'tree-item is-child';
        var childLink = document.createElement('a');
        childLink.href = buildUrlWithSearch(childNode.url, currentSearch);
        childLink.className = 'list-link';
        childLink.textContent = childNode.title + ' ';
        var childCountSpan = document.createElement('span');
        childCountSpan.className = 'item-count';
        childCountSpan.textContent = '(' + childNode.count + ')';
        childLink.appendChild(childCountSpan);
        childLi.appendChild(childLink);
        treeEl.appendChild(childLi);
      }
    });
  }
  originalList.style.display = 'none';
  originalList.parentNode.insertBefore(treeEl, originalList.nextSibling);
  container.classList.add('custom-sidebar-widget');
}

// ==========================================
// 3. MODE: CLASSIC CATEGORY TREE (FALLBACK)
// ==========================================
function transformCategoryFilterSearchanise() {
  var categoryBlock = document.querySelector('.snize-product-filters-block [data-se-facet-default-title="Category"]');
  if (!categoryBlock) return;
  var filterBlock = categoryBlock.closest('.snize-product-filters-block');
  if (!filterBlock) return;
  buildCategoryTree(filterBlock);
}
function transformMobileCategoryFilterSearchanise() {
  var mobileDialog = document.getElementById('snize-modal-mobile-filters-dialog');
  if (!mobileDialog) return;
  var firstCatCb = mobileDialog.querySelector('.snize-product-filters-checkbox[data-se-facet-default-title="Category"]');
  if (!firstCatCb) return;
  var filterContainer = firstCatCb.closest('.snize-product-filter-container');
  if (!filterContainer) return;
  buildCategoryTree(filterContainer);
}
function buildCategoryTree(container) {
  var originalList = container.querySelector('.snize-product-filters-list');
  if (!originalList) return;

  // Remove previous custom tree if it exists (rebuild on every update)
  var oldTree = container.querySelector('.snize-category-tree');
  if (oldTree) oldTree.remove();

  // Parse all checkbox items into a flat list
  var checkboxes = originalList.querySelectorAll('.snize-product-filters-checkbox');
  var items = [];
  checkboxes.forEach(function (cb) {
    var value = cb.value;
    var countEl = cb.closest('li').querySelector('.snize-filter-variant-count');
    var count = countEl ? parseInt(countEl.textContent.trim(), 10) || 0 : 0;
    items.push({
      value: value,
      count: count,
      checked: cb.checked,
      checkbox: cb
    });
  });

  // Filter out tags with zero quantity
  var filteredItems = items.filter(function (item) {
    return item.count > 0;
  });
  if (filteredItems.length === 0) return;

  // Build tree structure (only from non-zero items)
  var tree = {};
  filteredItems.forEach(function (item) {
    var parts = item.value.split('/');
    var node = tree;
    parts.forEach(function (part, i) {
      if (!node[part]) {
        node[part] = {
          _count: 0,
          _items: [],
          _children: {}
        };
      }
      node[part]._count += item.count;
      if (i === parts.length - 1) {
        node[part]._items.push(item);
      }
      node = node[part]._children;
    });
  });

  // Determine current drill-down state from checked checkboxes
  var activePath = getActivePath(filteredItems);

  // Render the tree UI
  var treeEl = document.createElement('ul');
  treeEl.className = activePath.length > 0 ? 'contextual-category-tree snize-category-tree' : 'global-category-list root-directory snize-category-tree';
  if (activePath.length > 0) {
    // Render back navigation
    var backLi = document.createElement('li');
    backLi.className = 'tree-item is-parent';
    var backLink = document.createElement('a');
    backLink.href = '#';
    backLink.innerHTML = '&laquo; All Categories';
    backLink.addEventListener('click', function (e) {
      e.preventDefault();
      uncheckAllCategoryCheckboxes(items);
    });
    backLi.appendChild(backLink);
    treeEl.appendChild(backLi);

    // Render intermediate parents
    for (var d = 0; d < activePath.length; d++) {
      var li = document.createElement('li');
      if (d === activePath.length - 1) {
        li.className = 'tree-item is-current';
        var span = document.createElement('span');
        var nodeData = getNodeAt(tree, activePath.slice(0, d + 1));
        span.textContent = activePath[d];
        var countSpan = document.createElement('span');
        countSpan.className = 'item-count';
        countSpan.textContent = ' (' + (nodeData ? nodeData._count : '') + ')';
        span.appendChild(countSpan);
        li.appendChild(span);
      } else {
        li.className = 'tree-item is-parent';
        var parentLink = document.createElement('a');
        parentLink.href = '#';
        parentLink.textContent = "\xAB " + activePath[d];
        (function (depth) {
          parentLink.addEventListener('click', function (e) {
            e.preventDefault();
            selectPrefix(items, activePath.slice(0, depth + 1).join('/'));
          });
        })(d);
        li.appendChild(parentLink);
      }
      treeEl.appendChild(li);
    }

    // Render children of the current active node
    var currentNode = getNodeAt(tree, activePath);
    if (currentNode) {
      var childKeys = Object.keys(currentNode._children);
      childKeys.forEach(function (childName) {
        var childData = currentNode._children[childName];
        var childLi = document.createElement('li');
        childLi.className = 'tree-item is-child';
        var childLink = document.createElement('a');
        childLink.href = '#';
        childLink.className = 'list-link';
        childLink.textContent = childName + ' ';
        var cSpan = document.createElement('span');
        cSpan.className = 'item-count';
        cSpan.textContent = '(' + childData._count + ')';
        childLink.appendChild(cSpan);
        var childPrefix = activePath.concat(childName).join('/');
        (function (prefix) {
          childLink.addEventListener('click', function (e) {
            e.preventDefault();
            selectPrefix(items, prefix);
          });
        })(childPrefix);
        childLi.appendChild(childLink);
        treeEl.appendChild(childLi);
      });
    }
  } else {
    // Root level: show top-level categories
    Object.keys(tree).forEach(function (rootName) {
      var rootData = tree[rootName];
      var li = document.createElement('li');
      li.className = 'list-item';
      var link = document.createElement('a');
      link.href = '#';
      link.className = 'list-link';
      link.textContent = rootName + ' ';
      var cSpan = document.createElement('span');
      cSpan.className = 'item-count';
      cSpan.textContent = '(' + rootData._count + ')';
      link.appendChild(cSpan);
      (function (name) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          selectPrefix(items, name);
        });
      })(rootName);
      li.appendChild(link);
      treeEl.appendChild(li);
    });
  }

  // Hide original list, insert tree
  originalList.style.display = 'none';
  originalList.parentNode.insertBefore(treeEl, originalList.nextSibling);

  // Add wrapper class for styling
  container.classList.add('custom-sidebar-widget');
}
function getActivePath(items) {
  var checked = items.filter(function (i) {
    return i.checked;
  });
  if (checked.length === 0) return [];
  var allParts = checked.map(function (i) {
    return i.value.split('/');
  });
  var prefix = [];
  for (var depth = 0; depth < allParts[0].length; depth++) {
    var segment = allParts[0][depth];
    var allMatch = allParts.every(function (parts) {
      return parts[depth] === segment;
    });
    if (allMatch) {
      prefix.push(segment);
    } else {
      break;
    }
  }
  return prefix;
}
function getNodeAt(tree, pathArray) {
  var node = tree;
  for (var i = 0; i < pathArray.length; i++) {
    if (!node[pathArray[i]]) return null;
    if (i === pathArray.length - 1) return node[pathArray[i]];
    node = node[pathArray[i]]._children;
  }
  return null;
}
function selectPrefix(items, prefix) {
  var toChange = [];
  items.forEach(function (item) {
    var shouldBeChecked = item.value === prefix || item.value.startsWith(prefix + '/');
    if (item.checkbox.checked !== shouldBeChecked) {
      toChange.push({
        checkbox: item.checkbox,
        target: shouldBeChecked,
        count: item.count
      });
    }
  });
  if (toChange.length === 0) return;
  toChange.sort(function (a, b) {
    return a.count - b.count;
  });
  for (var i = 0; i < toChange.length - 1; i++) {
    toChange[i].checkbox.checked = toChange[i].target;
  }
  toChange[toChange.length - 1].checkbox.click();
}
function uncheckAllCategoryCheckboxes(items) {
  var checked = items.filter(function (item) {
    return item.checkbox.checked;
  });
  if (checked.length === 0) return;
  checked.sort(function (a, b) {
    return a.count - b.count;
  });
  for (var i = 0; i < checked.length - 1; i++) {
    checked[i].checkbox.checked = false;
  }
  checked[checked.length - 1].checkbox.click();
}

/***/ },

/***/ "./src/scripts/collections/searchanise/searchanise-filters-customizations.js"
/*!***********************************************************************************!*\
  !*** ./src/scripts/collections/searchanise/searchanise-filters-customizations.js ***!
  \***********************************************************************************/
() {

var _initFilterCustomizations = function _initFilterCustomizations() {
  var $ = window.Searchanise.$;
  $(document).on('Searchanise.ResultsUpdated', function (event, container) {
    hideEmptyFilterOptions();
  });
  $(document).on('Searchanise.DataRequestEnd', function (event, type, params, data) {
    removeEmptyVendorFacets(data);
  });
};
if (window.Searchanise && window.Searchanise.$) {
  _initFilterCustomizations();
} else {
  document.addEventListener('Searchanise.Loaded', _initFilterCustomizations);
}

/**
 * Intercepts the Searchanise data response and removes any vendor facets that have 0 results.
 * This should work for all faces not just vendor
 */

var removeEmptyVendorFacets = function removeEmptyVendorFacets(data) {
  if (data && Array.isArray(data.facets)) {
    data.facets.forEach(function (facet) {
      if (Array.isArray(facet.buckets)) {
        facet.buckets = facet.buckets.filter(function (bucket) {
          var count = parseInt(bucket.count, 10);
          // Keep buckets that have a valid count greater than 0
          return !isNaN(count) && count > 0;
        });
      }
    });
  }
};

/**
 * Hides any filter option (checkbox/list item) if its count is 0.
 */
var hideEmptyFilterOptions = function hideEmptyFilterOptions() {
  var allFilterBlocks = document.querySelectorAll('.snize-product-filters-block, .snize-product-filter-container');
  allFilterBlocks.forEach(function (block) {
    // Determine if this block is for Brand or Vendor by checking its checkboxes
    var isBrandFilter = block.id === "snize_filters_block_vendor";
    if (isBrandFilter) {
      var visibleCount = 0;
      var listItems = block.querySelectorAll('li');
      listItems.forEach(function (li) {
        if (li.style.display !== 'none') {
          visibleCount++;
        }
      });
      if (visibleCount <= 1) {
        block.style.display = 'none';
      }
    }
    var isTagFilter = block.id === "snize_filters_block_tags";
    if (isTagFilter) {
      block.style.display = 'none';
    }
  });
};

/***/ },

/***/ "./src/scripts/collections/searchanise/searchanise-onsale-filter.js"
/*!**************************************************************************!*\
  !*** ./src/scripts/collections/searchanise/searchanise-onsale-filter.js ***!
  \**************************************************************************/
() {

function _initOnSaleFilter() {
  var $ = window.Searchanise.$;
  $(document).on('Searchanise.ResultsUpdated', function (event, container) {
    // A throw here would starve the later handlers (jQuery stops the dispatch), among them the
    // card price render.
    try {
      transformOnSaleFilter();
      transformMobileOnSaleFilter();
    } catch (e) {
      // let the later handlers run
    }
  });
}
if (window.Searchanise && window.Searchanise.$) {
  _initOnSaleFilter();
} else {
  document.addEventListener('Searchanise.Loaded', _initOnSaleFilter);
}

/**;
 * Transforms the Searchanise "Discount" filter into a toggle switch
 * matching the theme's native On Sale toggle style.
 */
function transformOnSaleFilter() {
  var filterBlock = document.getElementById('snize_filters_block_discount_relative');
  if (!filterBlock) return;
  var checkbox = filterBlock.querySelector('.snize-product-filters-checkbox[value="On Sale"]');
  if (!checkbox) return;

  // If already transformed, sync toggle state and return
  if (filterBlock.classList.contains('snize-onsale-transformed')) {
    var existingInput = filterBlock.querySelector('.filter-toggle-switch input');
    if (existingInput) existingInput.checked = checkbox.checked;
    return;
  }

  // Hide the original list
  var originalList = filterBlock.querySelector('.snize-product-filters-list');
  if (originalList) originalList.style.display = 'none';

  // Transform the title into toggle heading
  var title = filterBlock.querySelector('.snize-product-filters-title');
  if (!title) return;

  // Replace title text with "ON SALE"
  var titleSpan = title.querySelector('span');
  if (titleSpan) titleSpan.textContent = 'ON SALE';

  // Build toggle switch and append to title
  var toggle = document.createElement('span');
  toggle.className = 'filter-toggle-switch';
  var input = document.createElement('input');
  input.type = 'checkbox';
  input.checked = checkbox.checked;
  var slider = document.createElement('span');
  slider.className = 'filter-toggle-slider';
  toggle.appendChild(input);
  toggle.appendChild(slider);
  title.appendChild(toggle);

  // Prevent toggle clicks from bubbling to title (collapse/expand)
  toggle.addEventListener('click', function (e) {
    e.stopPropagation();
    var state = input.checked;
    input.checked = !state;
    // Sync with Searchanise checkbox
    if (checkbox.checked !== input.checked) {
      checkbox.click();
    }
  });
  filterBlock.classList.add('snize-onsale-transformed');
}

/**
 * Mobile: Transforms the Discount opener in the mobile filters dialog
 * into a direct ON SALE toggle (no navigation to sub-panel).
 */
function transformMobileOnSaleFilter() {
  var mobileDialog = document.getElementById('snize-modal-mobile-filters-dialog');
  if (!mobileDialog) return;
  var opener = mobileDialog.querySelector('.snize-product-filter-opener[data-se-facet-attribute="discount_relative"]');
  if (!opener) return;

  // Find the actual Searchanise checkbox in the mobile discount container
  var checkbox = mobileDialog.querySelector('#snize_product_filter_discount_relative .snize-product-filters-checkbox[value="On Sale"]');
  if (!checkbox) return;

  // If already transformed, sync toggle state and return
  if (opener.classList.contains('snize-onsale-transformed')) {
    var existingInput = opener.querySelector('.filter-toggle-switch input');
    if (existingInput) existingInput.checked = checkbox.checked;
    return;
  }

  // Change opener title to "ON SALE"
  var openerTitle = opener.querySelector('.snize-product-filter-title');
  if (openerTitle) openerTitle.textContent = 'ON SALE';

  // Build toggle switch
  var toggle = document.createElement('span');
  toggle.className = 'filter-toggle-switch';
  var input = document.createElement('input');
  input.type = 'checkbox';
  input.checked = checkbox.checked;
  var slider = document.createElement('span');
  slider.className = 'filter-toggle-slider';
  toggle.appendChild(input);
  toggle.appendChild(slider);
  opener.appendChild(toggle);

  // Capture-phase handler: block Searchanise navigation, toggle the checkbox
  opener.addEventListener('click', function (e) {
    e.stopPropagation();
    e.preventDefault();
    input.checked = !input.checked;
    if (checkbox.checked !== input.checked) {
      checkbox.click();
    }
  }, true);
  opener.classList.add('snize-onsale-transformed');
}

/***/ },

/***/ "./src/scripts/collections/searchanise/searchanise-update-data.js"
/*!************************************************************************!*\
  !*** ./src/scripts/collections/searchanise/searchanise-update-data.js ***!
  \************************************************************************/
() {

var _initUpdateData = function _initUpdateData() {
  var $ = window.Searchanise.$;
  $(document).on('Searchanise.DataRequestEnd', function (event, type, params, data) {
    cleanProductUrls(data);

    // Only the results payload owns the click-time price map: the widget fires the same event
    // for autocomplete / recommendation requests, whose items must never be normalised and
    // must never replace the summaries of the cards still on screen.
    if (type === 'results') buildPriceInfoMap(data);
    updateImageToFirstAvailable(data);
    removeCategoriesFromData(data);
    removePagesFromData(data);
    window.PFRO_ColorsVariants = getProductsWithColorVariants(data.items);
    console.log('Final Data:', data);
  });
};
if (window.Searchanise && window.Searchanise.$) {
  _initUpdateData();
} else {
  document.addEventListener('Searchanise.Loaded', _initUpdateData);
}

/**
 * Sanitizes product and variant URLs by removing the '/collections/collection-name' prefix.
 * Mutates the data object directly to maximize execution speed and minimize memory overhead.
 * * @param {Object} data - The Searchanise data payload
 */
var cleanProductUrls = function cleanProductUrls(data) {
  if (!data || !data.items) return;

  // RegEx to match '/collections/any-name' at the start of the path
  var collectionRegex = /^\/collections\/[^\/]+/;
  data.items.forEach(function (item) {
    // 1. Clean the main product link
    if (item.link) {
      item.link = item.link.replace(collectionRegex, '');
    }

    // 2. Clean the variant links
    if (item.shopify_variants) {
      item.shopify_variants.forEach(function (variant) {
        if (variant.link) {
          variant.link = variant.link.replace(collectionRegex, '');
        }
      });
    }
  });
};
/**
 * Updates the main product image with the image of the first available variant.
 * Fallbacks to the main image if the variant's image is empty.
 * Mutates the data directly for zero-overhead performance.
 * * @param {Object} data - The Searchanise data payload
 */
var updateImageToFirstAvailable = function updateImageToFirstAvailable(data) {
  if (!data || !data.items) return;

  // Initialize global storage for available variants
  window.PFRO_FirstAvailableVariants = window.PFRO_FirstAvailableVariants || {};
  data.items.forEach(function (item) {
    // Skip if there are no variants
    if (!item.shopify_variants || item.shopify_variants.length === 0) return;

    // Find the FIRST variant that is available AND has a valid, non-empty image_link
    var firstAvailableWithImage = item.shopify_variants.find(function (variant) {
      return variant.available === "1" && variant.image_link;
    });

    // If a valid variant is found, override the main product image and the default variant ID
    if (firstAvailableWithImage) {
      item.image_link = firstAvailableWithImage.image_link;
      item.add_to_cart_id = firstAvailableWithImage.variant_id;

      // Store it globally for synchronous DOM verification
      window.PFRO_FirstAvailableVariants[item.product_id] = {
        variant_id: firstAvailableWithImage.variant_id,
        image_link: firstAvailableWithImage.image_link,
        color: firstAvailableWithImage.options ? firstAvailableWithImage.options.Color : null
      };
    }
  });
};
var removeCategoriesFromData = function removeCategoriesFromData(data) {
  if (!data || !data.categories) return;
  data.categories = [];
};
var removePagesFromData = function removePagesFromData(data) {
  if (!data || !data.pages) return;
  data.pages = [];
};
var getProductsWithColorVariants = function getProductsWithColorVariants(productsJson) {
  return productsJson.reduce(function (result, product) {
    var uniqueColors = new Map();
    var firstAvailableColor = null;

    // Use the color that was chosen to be the main image
    if (window.PFRO_FirstAvailableVariants && window.PFRO_FirstAvailableVariants[product.product_id]) {
      firstAvailableColor = window.PFRO_FirstAvailableVariants[product.product_id].color;
    }

    // Check if the product has variants
    if (product.shopify_variants && Array.isArray(product.shopify_variants)) {
      product.shopify_variants.forEach(function (variant) {
        var colorName = variant.options && variant.options.Color;
        if (colorName) {
          var isAvailable = variant.available === "1";

          // If we haven't seen this color yet, add it
          if (!uniqueColors.has(colorName)) {
            uniqueColors.set(colorName, {
              color: colorName,
              // Use the variant's image if available, otherwise fallback to the product's main image
              image: variant.image_link || product.image_link,
              color_code: variant.color_code || null,
              available: isAvailable
            });
          } else {
            var existingColor = uniqueColors.get(colorName);

            // If any variant of this color is available, mark the color as available
            if (isAvailable) {
              existingColor.available = true;
            }

            // If we already added the color but it used the fallback image, 
            // update it if this current variant has a specific image
            if (!variant.image_link && existingColor.image === product.image_link) {
              if (variant.image_link) {
                existingColor.image = variant.image_link;
              }
            }
          }
        }
      });
    }
    var colorsArray = Array.from(uniqueColors.values());

    // Only include products that have more than one color variant
    if (colorsArray.length > 1) {
      result.push({
        product_id: product.product_id,
        title: product.title,
        link: product.link,
        colors: colorsArray,
        firstAvailableColor: firstAvailableColor || colorsArray[0].color
      });
    }
    return result;
  }, []);
};

/**
 * Parses a Searchanise numeric string ("97.9900") into a number.
 * @param {*} x - raw value
 * @returns {number} parsed number, 0 when unparsable
 */
var pfroNum = function pfroNum(x) {
  return parseFloat(x) || 0;
};

/**
 * Searchanise reports variant availability as the string "1" / "0".
 * @param {Object} v - shopify variant
 * @returns {boolean}
 */
var pfroIsAvailable = function pfroIsAvailable(v) {
  return !!v && String(v.available) === '1';
};

/**
 * Summarizes a pool of variants for card pricing.
 * ranged: the pool spans several prices.
 * showRange: ranged AND on sale -> the card shows "min - max". A pool whose prices merely differ
 * without any discount (denominations, kit tiers, pack sizes) keeps the widget's single "min",
 * so only the sale cases the client asked about change.
 * showCompare: every variant of the pool is discounted from the SAME compare-at price ->
 * strike-through, on a range as well ("$24.99 - $26.99" struck from "$34.99"), mirroring the
 * theme's native "From $X <s>$Y</s>" card.
 * percent: the biggest discount in the pool (sale sticker text).
 * @param {Array} pool - variants selected by pfroSelectPool
 * @returns {Object|null} summary, or null for an empty pool
 */
var pfroSummarize = function pfroSummarize(pool) {
  if (!pool || !pool.length) return null;
  var firstList = pfroNum(pool[0].list_price);
  var min = pfroNum(pool[0].price);
  var max = min;
  var onSale = false;
  var percent = 0;
  var allDiscounted = true;
  var sameList = true;
  for (var i = 0; i < pool.length; i++) {
    var price = pfroNum(pool[i].price);
    var list = pfroNum(pool[i].list_price);
    if (price < min) min = price;
    if (price > max) max = price;
    if (list > price) {
      onSale = true;
      var variantPercent = Math.round((list - price) / list * 100);
      if (variantPercent > percent) percent = variantPercent;
    } else {
      allDiscounted = false;
    }
    if (list !== firstList) sameList = false;
  }
  var ranged = max > min;
  var showCompare = allDiscounted && sameList;
  return {
    min: min,
    max: max,
    ranged: ranged,
    showRange: ranged && onSale,
    onSale: onSale,
    percent: onSale ? percent : 0,
    showCompare: showCompare,
    listPrice: showCompare ? firstList : 0,
    count: pool.length
  };
};

/**
 * Picks the variant pool the price is computed from: available variants (all variants when
 * nothing is available, mirroring the server/widget), optionally narrowed to one colour.
 * @param {Array} variants - item.shopify_variants
 * @param {string|null} color - exact options.Color value, or null for the whole pool
 * @returns {Array} pool (possibly empty)
 */
var pfroSelectPool = function pfroSelectPool(variants, color) {
  if (!variants || !variants.length) return [];
  var pool = variants.filter(function (variant) {
    return pfroIsAvailable(variant);
  });
  if (!pool.length) pool = variants.slice();
  if (color) {
    var byColor = pool.filter(function (variant) {
      return !!variant.options && variant.options.Color === color;
    });
    if (!byColor.length) {
      byColor = variants.filter(function (variant) {
        return !!variant.options && variant.options.Color === color;
      });
    }
    if (byColor.length) pool = byColor;
  }
  return pool;
};

/**
 * Builds the per-product pricing info consumed by the card renderer and the sale badge.
 * Returns null when the item has no variants, when none of them carries a usable price, or
 * when NO variant is available at all: a fully sold-out card keeps the widget's own price
 * output (the server prints the first variant's price there) and the legacy top-level badge
 * logic. The colour-filter fallback inside pfroSelectPool is unaffected.
 * @param {Object} item - Searchanise item
 * @returns {Object|null} { product_id, colorOption, all, byColor }
 */
var pfroBuildPriceInfo = function pfroBuildPriceInfo(item) {
  var variants = item ? item.shopify_variants : null;
  if (!Array.isArray(variants) || !variants.length) return null;
  var hasPrice = variants.some(function (variant) {
    return pfroNum(variant.price) > 0;
  });
  if (!hasPrice) return null;
  var hasAvailable = variants.some(function (variant) {
    return pfroIsAvailable(variant);
  });
  if (!hasAvailable) return null;
  var all = pfroSummarize(pfroSelectPool(variants, null));
  if (!all) return null;
  var colors = [];
  variants.forEach(function (variant) {
    var colorName = variant.options && variant.options.Color;
    if (colorName && colors.indexOf(colorName) === -1) colors.push(colorName);
  });
  var byColor = {};
  colors.forEach(function (colorName) {
    var summary = pfroSummarize(pfroSelectPool(variants, colorName));
    if (summary) byColor[colorName] = summary;
  });
  return {
    product_id: item.product_id,
    colorOption: colors.length ? 'Color' : null,
    all: all,
    byColor: byColor
  };
};

/**
 * Formats an amount with the widget's own money formatter (store PriceFormat options),
 * falling back to "$1,234.50" when the widget API is not reachable.
 * @param {number} n - amount
 * @returns {string}
 */
var pfroFormatMoney = function pfroFormatMoney(n) {
  var amount = typeof n === 'number' && isFinite(n) ? n : pfroNum(n);
  try {
    if (window.Searchanise && typeof window.Searchanise.GetWidgets === 'function') {
      var widgets = window.Searchanise.GetWidgets();
      if (widgets && typeof widgets.formatPrice === 'function') return widgets.formatPrice(amount);
    }
  } catch (e) {
    // fall through to the local formatter
  }
  var parts = amount.toFixed(2).split('.');
  return '$' + parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
};

/**
 * Card price text for a summary: an en-dashed range (only when the pool is on sale) or a
 * single amount.
 * @param {Object} summary - pfroSummarize result
 * @returns {string}
 */
var pfroPriceText = function pfroPriceText(summary) {
  if (!summary) return '';
  if (summary.showRange) return pfroFormatMoney(summary.min) + ' \u2013 ' + pfroFormatMoney(summary.max);
  return pfroFormatMoney(summary.min);
};

/**
 * Merges the pricing info of a 'results' payload into window.PFRO_PriceInfo and normalises every
 * item's top-level price / list_price to the whole-pool summary, keeping the originals in
 * item.pfro_price_original. Merged (not replaced) so that entries of a page whose cards are still
 * in the DOM survive a later request; ids of the new payload always win.
 * @param {Object} data - the Searchanise data payload ('results' only)
 */
var buildPriceInfoMap = function buildPriceInfoMap(data) {
  if (!data || !data.items) return;
  var map = window.PFRO_PriceInfo || {};
  data.items.forEach(function (item) {
    var info = pfroBuildPriceInfo(item);
    if (!info) {
      // A product that flipped to fully sold out (or lost its prices) must not keep a stale entry
      delete map[item.product_id];
      return;
    }
    map[item.product_id] = info;

    // Written once: re-processing the same item object must not overwrite the true server values
    if (!item.pfro_price_original) {
      item.pfro_price_original = {
        price: item.price,
        list_price: item.list_price
      };
    }
    item.price = info.all.min.toFixed(4);
    item.list_price = (info.all.showCompare ? info.all.listPrice : 0).toFixed(4);
  });
  window.PFRO_PriceInfo = map;
};

// Shared with searchanise-badges.js / searchanise-card-product-customizations.js
window.PFRO_PriceUtils = {
  summarize: pfroSummarize,
  selectPool: pfroSelectPool,
  buildPriceInfo: pfroBuildPriceInfo,
  formatMoney: pfroFormatMoney,
  priceText: pfroPriceText
};

/***/ }

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Check if module exists (development only)
/******/ 		if (__webpack_modules__[moduleId] === undefined) {
/******/ 			var e = new Error("Cannot find module '" + moduleId + "'");
/******/ 			e.code = 'MODULE_NOT_FOUND';
/******/ 			throw e;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
/*!************************************************************!*\
  !*** ./src/scripts/collections/searchanise/searchanise.js ***!
  \************************************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _searchanise_update_data_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./searchanise-update-data.js */ "./src/scripts/collections/searchanise/searchanise-update-data.js");
/* harmony import */ var _searchanise_update_data_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_searchanise_update_data_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _searchanise_badges_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./searchanise-badges.js */ "./src/scripts/collections/searchanise/searchanise-badges.js");
/* harmony import */ var _searchanise_badges_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_searchanise_badges_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _searchanise_banner_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./searchanise-banner.js */ "./src/scripts/collections/searchanise/searchanise-banner.js");
/* harmony import */ var _searchanise_banner_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_searchanise_banner_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _searchanise_onsale_filter_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./searchanise-onsale-filter.js */ "./src/scripts/collections/searchanise/searchanise-onsale-filter.js");
/* harmony import */ var _searchanise_onsale_filter_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_searchanise_onsale_filter_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _searchanise_card_product_customizations_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./searchanise-card-product-customizations.js */ "./src/scripts/collections/searchanise/searchanise-card-product-customizations.js");
/* harmony import */ var _searchanise_card_product_customizations_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_searchanise_card_product_customizations_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _searchanise_category_filter_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./searchanise-category-filter.js */ "./src/scripts/collections/searchanise/searchanise-category-filter.js");
/* harmony import */ var _searchanise_category_filter_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_searchanise_category_filter_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _searchanise_filters_customizations_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./searchanise-filters-customizations.js */ "./src/scripts/collections/searchanise/searchanise-filters-customizations.js");
/* harmony import */ var _searchanise_filters_customizations_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_searchanise_filters_customizations_js__WEBPACK_IMPORTED_MODULE_6__);







function _initCore() {
  var $ = window.Searchanise.$;
  $(document).on('Searchanise.ResultsUpdated', function () {
    var skeleton = document.getElementById('snize_skeleton_results');
    if (skeleton) skeleton.style.display = 'none';
  });
}
if (window.Searchanise && window.Searchanise.$) {
  _initCore();
} else {
  document.addEventListener('Searchanise.Loaded', _initCore);
}
})();

/******/ })()
;